import {callsApi} from 'sources/api';
import {CommentId, UserComment} from 'records/UserComment';
import {FileUploadId} from 'records/CoachingReviewFileUpload';
import {Seconds} from '@store/@types/util';
import {
  CreateCommentRequest,
  CreateHighlightRequest,
  UpdateCommentRequest,
  UpdateHighlightRequest,
} from '@store/call-card/CommentSource.types';
import clamp from 'lodash/clamp';

export default class CommentSource {
  static createComment(id: FileUploadId, comment: UserComment, duration: Seconds): Promise<void> {
    return callsApi.postJson<CreateCommentRequest>(`/comments/${id}`, {
      message: comment.message,
      taggedUsers: comment.taggedUsers,
      location: comment.location ?? clamp(comment.startTime / duration, 0, 1),
    });
  }

  static updateComment(
    id: FileUploadId,
    comment: UserComment,
    duration: Seconds
  ): Promise<UserComment> {
    return callsApi
      .putJson<UpdateCommentRequest>(`/comments/${id}/comment/${comment.id}`, {
        message: comment.message,
        taggedUsers: comment.taggedUsers,
        location: comment.location ?? clamp(comment.startTime / duration, 0, 1),
        id: comment.id!,
      })
      .then(comment => new UserComment(comment, duration));
  }

  static deleteComment(id: FileUploadId, comment: UserComment): Promise<void> {
    return callsApi.delete(`/comments/${id}/comment/${comment.id}`);
  }

  static createHighlight(
    id: FileUploadId,
    comment: UserComment,
    duration: Seconds
  ): Promise<{id: CommentId}> {
    return callsApi.postJson<CreateHighlightRequest>(`/highlights/${id}`, {
      color: comment.color!,
      content: comment.message,
      start: Math.max(comment.startTime / duration, 0),
      end: Math.min(comment.endTime / duration, 1),
      taggedUsers: comment.taggedUsers ?? [],
      primary: true,
    });
  }

  static updateHighlight(id: FileUploadId, comment: UserComment, duration: Seconds): Promise<void> {
    return callsApi.putJson<UpdateHighlightRequest>(`/highlights/${id}/highlight/${comment.id}`, {
      color: comment.color!,
      id: comment.id!,
      content: comment.message,
      start: Math.max(comment.startTime / duration, 0),
      end: Math.min(comment.endTime / duration, 1),
      taggedUsers: comment.taggedUsers ?? [],
      primary: true,
    });
  }
}
